import { ProtocolNames } from "./ProtocolNames";
import { ProtocolSettings } from "./ProtocolSettings";
import { SnmpSettings } from "./SnmpSettings";
import { PingSettings } from "./PingSettings";
import { WindowsSettings } from "./WindowsSettings";
import { SshSettings } from "./SshSettings";
import { TelnetSettings } from "./TelnetSettings";
import { VimSettings } from "./VimSettings";
import { PrtgSettings } from "./PrtgSettings";
import { HttpSettings } from "./HttpSettings";

export class ProtocolSettingsTypes {

	public static readonly None = "none";
	public static readonly Snmp = "snmp";
	public static readonly Windows = "windows";
	public static readonly Ssh = "ssh";
	public static readonly Telnet = "telnet";
	public static readonly Ping = "ping";
	public static readonly Vim = "vim";
	public static readonly Prtg = "prtg";
	public static readonly AWS = "aws";
	public static readonly HTTP = "http";

	public static GetProtocolName(protoSettingsType: string): string {
		if (!protoSettingsType)
			return "";

		let protocolName = "";

		switch (protoSettingsType) {
			case ProtocolSettingsTypes.Ping:
				protocolName = ProtocolNames.Ping;
				break;

			case ProtocolSettingsTypes.Windows:
				protocolName = ProtocolNames.Wmi;
				break;

			case ProtocolSettingsTypes.Snmp:
				protocolName = ProtocolNames.Snmp;
				break;

			case ProtocolSettingsTypes.Ssh:
				protocolName = ProtocolNames.Ssh;
				break;

			case ProtocolSettingsTypes.Telnet:
				protocolName = ProtocolNames.Telnet;
				break;

			case ProtocolSettingsTypes.Vim:
				protocolName = ProtocolNames.Vim;
				break;

			case ProtocolSettingsTypes.Prtg:
				protocolName = ProtocolNames.Prtg;
				break;

			case ProtocolSettingsTypes.AWS:
				protocolName = ProtocolNames.AWS;
				break;

			case ProtocolSettingsTypes.HTTP:
				protocolName = ProtocolNames.HTTP;
				break;

			default:
				console.assert(false);
				protocolName = protoSettingsType;
				break;
		}

		return protocolName;
	}

	public static CreateProtocolSettingsByType(settingsType: string): ProtocolSettings {
		switch (settingsType) {
			case ProtocolSettingsTypes.Ping:
				return new PingSettings();

			case ProtocolSettingsTypes.Windows:
				return new WindowsSettings();

			case ProtocolSettingsTypes.Snmp:
				return new SnmpSettings();

			case ProtocolSettingsTypes.Ssh:
				return new SshSettings();

			case ProtocolSettingsTypes.Telnet:
				return new TelnetSettings();

			case ProtocolSettingsTypes.Vim:
				return new VimSettings();

			case ProtocolSettingsTypes.Prtg:
				return new PrtgSettings();

			case ProtocolSettingsTypes.HTTP:
				return new HttpSettings();

			default:
				console.assert(false);
				return null;
		}
	}

}

